"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _propTypes = require("prop-types");
var _dcCore = require("dc-core");
const _excluded = ["locale", "messages"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; } /*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const loadTranslations = locale => {
  let localeNormalized = _dcCore.locale2.normalizeLocale(locale);
  const languagePath = `../translations/${localeNormalized}.json`;
  if (!localeNormalized) localeNormalized = "en-US"; // default locale
  return (specifier => new Promise(r => r(specifier)).then(s => _interopRequireWildcard(require(s))))(`${languagePath}`).catch(() => Promise.resolve().then(() => _interopRequireWildcard(require("../translations/en-US.json")))); // incase of error use English
};
const wrapOriginalApp = OriginalApp => {
  const InjectedApp = (0, _reactIntl.injectIntl)(OriginalApp);
  const Wrapped = props => {
    // eslint-disable-next-line prefer-const
    let {
        locale,
        messages
      } = props,
      otherProps = _objectWithoutProperties(props, _excluded);
    if (!locale) locale = "en-US";
    return /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, {
      locale: locale,
      messages: messages
    }, /*#__PURE__*/_react.default.createElement(InjectedApp, otherProps));
  };
  Wrapped.propTypes = {
    locale: _propTypes.PropTypes.string.isRequired,
    messages: _propTypes.PropTypes.object.isRequired
  };
  return Wrapped;
};

// eslint-disable-next-line max-len
const localizeApp = (OriginalApp, options) => _dcCore.locale2.withTranslations(wrapOriginalApp(OriginalApp), loadTranslations, options);
var _default = exports.default = localizeApp;